<div class="bg-white px-5 py-3 border-round-2xl box-shadow">
    <form [formGroup]="form" class="w-full">
  
      <div class="grid p-fluid" *ngIf="filterBySplit">
        <div class="col-12 lg:col-3">
          <p-selectButton
            [options]="[
              { label: 'Mês a mês', value: 'mes a mes' },
              { label: 'Anual', value: 'anual' }
            ]"
            (onOptionClick)="onOptionClick($event)"
            optionLabel="label"
            optionValue="value"
            [allowEmpty]="false"
            formControlName="selectButtonFrequency"
          ></p-selectButton>
        </div>
        <div class="col-12 lg:col-5">
          <p-dropdown
            [options]="monthOptions"
            [autoDisplayFirst]="false"
            placeholder="Data"
            optionLabel="label"
            optionValue="value"
            formControlName="dropdownPeriod"
            (onChange)="addNewFilterEvent()"
          ></p-dropdown>
        </div>
        
        <div class="col-12 lg:col-4">
          <p-dropdown
            [options]="[{label: 'Copacabana', value: 'copacabana'},{label: 'Flamengo', value: 'flamengo'}]"
            [autoDisplayFirst]="false"
            placeholder="Todos os endereços"
            optionLabel="label"
            optionValue="value"
            formControlName="dropdownAddress"
            (onChange)="addNewFilterEvent()"
          ></p-dropdown>
        </div>
      </div>
  
      <div class="grid p-fluid" *ngIf="!filterBySplit">
        <div class="col-4">
          <p-selectButton
            [options]="[
              { label: 'Mês a mês', value: 'mes a mes' },
              { label: 'Trimestral', value: 'trimestral' },
              { label: 'Anual', value: 'anual' }
            ]"
            (onOptionClick)="onOptionClick($event)"
            optionLabel="label"
            optionValue="value"
            [allowEmpty]="false"
            formControlName="selectButtonFrequency"
          ></p-selectButton>
        </div>
        <div class="col-4">
          <p-dropdown
            [options]="monthOptions"
            [autoDisplayFirst]="false"
            placeholder="Data"
            optionLabel="label"
            optionValue="value"
            formControlName="dropdownPeriod"
            (onChange)="addNewFilterEvent()"
          ></p-dropdown>
        </div>
      </div>
    </form>
  </div>
  